@if (open() && !isDuplicating()) {
  <app-modal
    [config]="formModalConfig"
    [title]="'features.plan.duplicate.title' | translate"
    (closeModal)="closeForm()">
    <app-plan-details-form
      modal-body
      [initialName]="suggestedName()"
      [initialDescription]="sourceDescription()"
      [submitLabel]="'common.duplicate' | translate"
      [submitIcon]="ICONS.copy"
      (submitted)="onDuplicate($event)"
      (closeModal)="closeForm()" />
  </app-modal>
}

@if (isDuplicating()) {
  <app-modal
    [config]="progressModalConfig"
    [title]="'features.plan.duplicate.title' | translate">
    <div modal-body class="flex flex-col items-center gap-4 px-4 py-8 text-center">
      <div
        class="border-accent-main h-10 w-10 animate-spin rounded-full border-2 border-b-transparent"></div>
      <p class="text-text-secondary max-w-xs text-sm">
        {{
          (redirectOnComplete()
            ? 'features.plan.duplicate.in_progress'
            : 'features.plan.duplicate.in_progress_no_redirect'
          ) | translate
        }}
      </p>
    </div>
  </app-modal>
}
